import { KVCameraView } from './KVCameraView'
import { KVOrientationAxes } from './KVOrientationAxes'

export class KVSceneSettings {
  startingView: KVCameraView | null
  orientationAxes: KVOrientationAxes | null
  occludeWorldSpaceItems: boolean

  constructor() {
    this.startingView = null
    this.orientationAxes = null
    this.occludeWorldSpaceItems = false
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVSceneSettings {
    const kvSettings = new KVSceneSettings()
    if (json.startingView)
      kvSettings.startingView = KVCameraView.fromJSON(json.startingView)
    if (json.orientationAxes)
      kvSettings.orientationAxes = KVOrientationAxes.fromJSON(
        json.orientationAxes
      )
    if (typeof json.occludeWorldSpaceItems === 'boolean') {
      kvSettings.occludeWorldSpaceItems = json.occludeWorldSpaceItems
    }
    return kvSettings
  }

  static toJSON(kvSettings: KVSceneSettings): any {
    const json: any = {}
    if (kvSettings.startingView) {
      json.startingView = KVCameraView.toJSON(kvSettings.startingView)
    }
    if (kvSettings.orientationAxes) {
      json.orientationAxes = KVOrientationAxes.toJSON(
        kvSettings.orientationAxes
      )
    }
    json.occludeWorldSpaceItems = kvSettings.occludeWorldSpaceItems
    return json
  }
}
